import { history } from '@umijs/max';
import { Modal } from 'antd';
import { queryChatModelReadiness } from '@/services/bff/ai-model.api';

const CRM_AI_MODEL_BINDING_PATH = '/setting/general/ai-model-binding';
const MODEL_NOT_CONFIGURED = 'CRM_AI_MODEL_NOT_BOUND';

export const getCrmErrorCode = (error: unknown) => {
  const record = error as {
    code?: unknown;
    data?: { code?: unknown; message?: unknown };
    info?: { code?: unknown; message?: unknown };
  };
  const nestedMessage =
    typeof record?.data?.message === 'object'
      ? (record.data.message as { code?: unknown })
      : typeof record?.info?.message === 'object'
        ? (record.info.message as { code?: unknown })
        : undefined;
  const code =
    record?.code ??
    record?.data?.code ??
    record?.info?.code ??
    nestedMessage?.code;
  return typeof code === 'string' ? code : undefined;
};

export const showAiModelConfigDialog = () => {
  Modal.confirm({
    closable: { 'aria-label': '关闭' },
    keyboard: true,
    title: 'AI 模型未绑定',
    content:
      '当前 CRM 还没有绑定默认 AI 模型，请先到系统设置中的模型设置页面完成配置。',
    okText: '去绑定',
    cancelText: '取消',
    onOk: () => {
      history.push(CRM_AI_MODEL_BINDING_PATH);
    },
  });
};

export async function ensureChatModelReady() {
  try {
    const readiness = await queryChatModelReadiness();
    if (!readiness?.ready) {
      showAiModelConfigDialog();
      return false;
    }
    return true;
  } catch (error) {
    if (getCrmErrorCode(error) === MODEL_NOT_CONFIGURED) {
      showAiModelConfigDialog();
      return false;
    }
    throw error;
  }
}
